// import portfolio from '../../../../assets/portfolio.mp4';
import prep from '../../../../assets/prepify.mp4';
// import PortfolioMobile from '../../../../assets/portfolio_mobile.png'
import PrepifyMobile from '../../../../assets/prep_mobile.png'


export const currentPieces = [
    {
        title: 'PrEPify',
        media: prep,
        mobileMedia: PrepifyMobile,
        github: 'https://github.com/Savannah-Shifflet/prepify-mobile',
        deployed: '',
        disabled: true,
        summary: `A mobile application that helps you track your adherence to pre-exposure prophylaxis (or PrEP) using the evidence-based on-demand method. PrEP is a medication taken to prevent getting HIV.`,
        technology: [
            { source: 'https://img.shields.io/badge/React_Native-20232A?style=for-the-badge&logo=react&logoColor=61DAFB',
            alt: 'React Native'
            },
            { source: 'https://img.shields.io/badge/Expo-000020.svg?style=for-the-badge&logo=Expo&logoColor=white',
            alt: 'Expo'
            },
            { source: 'https://img.shields.io/badge/JavaScript-F7DF1E.svg?style=for-the-badge&logo=JavaScript&logoColor=black',
            alt: 'JavaScript'
            },
            { source: 'https://img.shields.io/badge/Node.js-339933.svg?style=for-the-badge&logo=nodedotjs&logoColor=white',
            alt: 'Node.Js'
            },
            { source: 'https://img.shields.io/badge/Express-000000.svg?style=for-the-badge&logo=Express&logoColor=white',
            alt: 'Express'
            },
            { source: 'https://img.shields.io/badge/PostgreSQL-4169E1.svg?style=for-the-badge&logo=PostgreSQL&logoColor=white',
            alt: 'Postgres'
            },
            { source: 'https://img.shields.io/badge/Sequelize-52B0E7.svg?style=for-the-badge&logo=Sequelize&logoColor=white',
            alt: 'Sequelize'
            },
            { source: 'https://img.shields.io/badge/Apollo%20GraphQL-311C87.svg?style=for-the-badge&logo=Apollo-GraphQL&logoColor=white',
            alt: 'GraphQL'
            },
            { source: 'https://img.shields.io/badge/Firebase-FFCA28.svg?style=for-the-badge&logo=Firebase&logoColor=black',
            alt: 'Firebase Auth'
            },
        ],
    },
   
];


// {
//     title: 'Portfolio Website',
//     media: portfolio,
//     mobileMedia: PortfolioMobile,
//     github: 'https://github.com/Savannah-Shifflet/professional-portfolio',
//     deployed: 'savannahshifflet.com',
//     summary: 'A front-end React-based web application that utilizes Material UI to bring my design to life. My website is a continuous work in progress as I build out more features.',
//     technology: [
//         { source: 'https://img.shields.io/badge/JavaScript-F7DF1E.svg?style=for-the-badge&logo=JavaScript&logoColor=black',
//         alt: 'JavaScript'
//         },
//         { source: 'https://img.shields.io/badge/Node.js-339933.svg?style=for-the-badge&logo=nodedotjs&logoColor=white',
//         alt: 'Node.Js'
//         },
//         { source: 'https://img.shields.io/badge/React-61DAFB.svg?style=for-the-badge&logo=React&logoColor=black',
//         alt: 'React'
//         },
//         { source: 'https://img.shields.io/badge/React%20Router-CA4245.svg?style=for-the-badge&logo=React-Router&logoColor=white',
//         alt: 'React Router'
//         },
//         { source: 'https://img.shields.io/badge/Material--UI-0081CB?style=for-the-badge&logo=mui&logoColor=white',
//         alt: 'Material UI'
//         },
//         { source: 'https://img.shields.io/badge/Netlify-00C7B7.svg?style=for-the-badge&logo=Netlify&logoColor=white',
//         alt: 'Netlify'
//         },
//         { source: 'https://img.shields.io/badge/Figma-F24E1E.svg?style=for-the-badge&logo=Figma&logoColor=white',
//         alt: 'Figma'
//         },
//     ],
// }